import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusBadge, Money } from "@/components/shared/Common";
import { Video, FileText } from "lucide-react";

export default function PatientAppointments() {
  const [appts, setAppts] = useState([]);
  useEffect(() => { api.get("/appointments/mine").then(r => setAppts(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div><div className="cm-eyebrow mb-2">Appointments</div><h1 className="cm-h2">Your consultations</h1></div>
      <div className="cm-card divide-y divide-[#e2e8f0]" data-testid="appts-list">
        {appts.length === 0 && <div className="text-sm text-[#475569] py-2">No appointments yet.</div>}
        {appts.map(a => (
          <div key={a.id} className="py-4 first:pt-0 last:pb-0 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <div className="font-semibold text-[#1a2b4a]">{a.doctor_name}</div>
              <div className="text-xs text-[#475569] capitalize">{a.specialty?.replace("_"," ")} · {a.consultation_type}</div>
              <div className="text-xs text-[#94a3b8] mt-1">{(a.slot_datetime||"").replace("T"," ").slice(0,16)}</div>
            </div>
            <div className="flex items-center gap-3">
              <StatusBadge status={a.status}/>
              <div className="text-sm font-semibold text-[#1a2b4a]"><Money amount={a.price} currency={a.currency}/></div>
              {a.status === "confirmed" && (
                <Link to={`/patient/video/${a.id}`} className="cm-btn-primary" data-testid={`join-${a.id}`}><Video size={14}/>Join</Link>
              )}
              {a.status === "completed" && (
                <Link to={`/patient/video/${a.id}`} className="cm-btn-outline" data-testid={`notes-${a.id}`}><FileText size={14}/>Notes</Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
